module.exports = __webpack_public_path__ + "img/bg_default.6baae419.png";